var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-table',{ref:"childTable",staticClass:"childTable",attrs:{"row-key":"customerCourseId","row-selection":_vm.childRowKeys,"columns":_vm.columns,"data-source":_vm.dataSource,"pagination":false},scopedSlots:_vm._u([{key:"progress",fn:function(text, record){return _c('span',{},[_c('a-progress',{attrs:{"percent":text.progress}})],1)}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }